import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux'
import {getFormValues} from 'redux-form'
import {hideConfirmSubmitModal, createPO, createAndFulfilledPO, editPO} from 'actions/inventory/purchaseOrder'
import styles from './ConfirmSubmitModal.css'
import * as mpPurchaseOrders from 'mixpanel/inventory/purchaseOrders'

class ConfirmSubmitModal extends React.Component {
  render () {
    const {confirmSubmitModal} = this.props
    return (<Modal show={confirmSubmitModal.show} dialogClassName={styles['modal-dialog']}>
      <Modal.Header bsClass={`modal-header ${styles['modal-header']}`}>
        Information
      </Modal.Header>
      {confirmSubmitModal.action !== 'createFulfilled' && <Modal.Body>
        Are you sure you want to proceed?
      </Modal.Body>}
      {confirmSubmitModal.action === 'createFulfilled' && <Modal.Body>
        Are you sure you want to proceed? You cannot edit or cancel this Purchase Order after creating.
      </Modal.Body>}
      <Modal.Footer>
        <button type='button' onClick={this._onHide} className='btn btn-default'>Cancel</button>
        <button
          type='button'
          className='btn btn-primary'
          onClick={this._onClickCreate}
        >
          OK
        </button>
      </Modal.Footer>
    </Modal>)
  }

  _onHide = () => {
    const {dispatch} = this.props
    dispatch(hideConfirmSubmitModal())
  }

  _onClickCreate = () => {
    const {dispatch, POForm, confirmSubmitModal, search: {namespace, date}, suppliers, outlets} = this.props
    // TODO seharusnya supplierid insteadof name
    const supplierId = POForm.supplierName
    let supplier = {}
    let outlet = {}
    // search supplier name
    suppliers.forEach(s => {
      if (s.id === parseInt(supplierId)) {
        supplier = s
      }
    })
    // search outlet name
    outlets.forEach(o => {
      if (o.id === POForm.outlet) {
        outlet = o
      }
    })
    if (confirmSubmitModal.action) {
      if (confirmSubmitModal.action === 'create' || confirmSubmitModal.action === 'createFulfilled') {
        mpPurchaseOrders.inventoryPOCreate({
          fulfilled: confirmSubmitModal.action === 'createFulfilled',
          namespace,
          supplier,
          outlet,
          items: POForm.itemPurchase
        })
      }
      if (confirmSubmitModal.action === 'create') {
        dispatch(createPO(namespace, POForm, date))
      } else if (confirmSubmitModal.action === 'createFulfilled') {
        dispatch(createAndFulfilledPO(namespace, POForm, date))
      } else {
        dispatch(editPO(namespace, POForm))
      }
    }
    dispatch(hideConfirmSubmitModal())
  }
}

function mapStateToProps (state) {
  const {confirmSubmitModal, outlets, suppliers} = state.inventory.purchaseOrder
  return {
    POForm: getFormValues('purchaseOrder')(state),
    search: getFormValues('search')(state),
    confirmSubmitModal,
    outlets,
    suppliers
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmSubmitModal)



// WEBPACK FOOTER //
// ./app/pages/Inventory/PurchaseOrder/FormPurchaseOrder/ConfirmSubmitModal/ConfirmSubmitModal.js